var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompletedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14076 16C12.5353 16 16.1445 12.3983 16.1445 8.00378C16.1445 3.60925 12.5353 0 8.14076 0C3.74623 0 0.144531 3.60925 0.144531 8.00378C0.144531 12.3983 3.75378 16 8.14076 16ZM7.12896 12.0887C6.78918 12.0887 6.5098 11.9226 6.28328 11.6583L4.11622 9.08353C3.935 8.87966 3.86704 8.67579 3.86704 8.44927C3.86704 7.96602 4.25968 7.58848 4.72783 7.58848C5.0072 7.58848 5.22617 7.7093 5.43004 7.93582L7.11386 9.97452L10.338 4.86267C10.5494 4.53799 10.7986 4.37187 11.1082 4.37187C11.5688 4.37187 11.9916 4.71166 11.9916 5.1949C11.9916 5.38367 11.9161 5.59509 11.7878 5.79141L7.95954 11.6206C7.76322 11.9151 7.46119 12.0887 7.12896 12.0887Z",
    fill: "#009900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedIcon);
export default __webpack_public_path__ + "static/media/completedIcon.5ebf634cdf2b4e2d7c027e71ebe1f8a5.svg";
export { ForwardRef as ReactComponent };